import { errorToast, successToast } from "../../toastmessage/toastmessage";
import { fetchPdf } from "./patientService";

function usePatientHook() {

    const handlePdfClick = async (row) => {
        try {
            let result = await fetchPdf()
            const blobUrl = URL.createObjectURL(result?.data);
            window.open(blobUrl, '_blank');
            successToast("File Opend In Next Tab Successfully")
        } catch (e) {
            errorToast("Failed to load")

        }
       
    }

    return {
        handlePdfClick


    };
}

export default usePatientHook;






